import { render, staticRenderFns } from "./studentDialog.vue?vue&type=template&id=6b39e998&scoped=true"
import script from "./studentDialog.vue?vue&type=script&lang=js"
export * from "./studentDialog.vue?vue&type=script&lang=js"
import style0 from "./studentDialog.vue?vue&type=style&index=0&id=6b39e998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b39e998",
  null
  
)

export default component.exports